import { useState, useEffect, useMemo } from "react";
import Logo from "../Logo";
import style from "./style.module.scss";
import { Link, useMatch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UseApp } from "../../../../context/AppContext";
import { UseSetting } from "../../../../context/SettingContext";
import { getFormSettings } from "../../../../utils/functions";
import { UseModal } from "../../../../context/ModalContext";

const SideBar = () => {
  const { t } = useTranslation();
  const isHomeRoute = useMatch("/:client");
  const {
    appState: { isMobile, language },
  } = UseApp();

  const [mobileClass, setMobileClass] = useState(null);
  const { handleModalOpen } = UseModal();

  useEffect(() => {
    if (isMobile && isHomeRoute) {
      setMobileClass(style.splashvisible);
      const timer = setTimeout(() => {
        setMobileClass("");
      }, 3000);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [isMobile, isHomeRoute]);

  const { settings } = UseSetting();

  const formSettings = useMemo(() => {
    return {
      generalSettings: getFormSettings(settings, "StartForm", {
        lang: language,
      }),
    };
  }, [settings, language]);

  /** Prepare form header note */
  let title = "";
  if (formSettings?.generalSettings?.CentralTextTitle?.ItemValue) {
    title = formSettings?.generalSettings?.CentralTextTitle?.ItemValue;
  } else {
    title = t("MINTZ_GLOBAL_SCREENING");
  }

  const openTermsNConditionModal = (event) => {
    event.preventDefault();
    handleModalOpen("termsNconditions", {
      className: "VerticalModal",
    });
  };

  /**
   * Open privacy modal
   * @param {*}
   */
  const openPrivacyPolicyModal = (event) => {
    event.preventDefault();
    handleModalOpen("privacyPolicy", {
      className: "VerticalModal",
    });
  };

  return (
    <div className={`home-page ${style.captionContainer} ${mobileClass}`}>
      <div className={style.BannerLogo}>
        <Logo />
      </div>
      <div className={style.BannerText}>
        <div className={style.BannerTitles}>
          <strong>{t("WELCOME")}</strong> {t("TO_PORTAL")}
        </div>
        <br />
        <br />
        <h1>{title}</h1>
      </div>

      <div className={style.CopyRight}>
        <div className={style.TermsPolicy}>
          <Link to="/" onClick={openTermsNConditionModal}>
            {t("TERM_USE")}
          </Link>
          <span> {t("AND")} </span>
          <Link to="/" onClick={openPrivacyPolicyModal}>
            {t("PRIVACY_POLICY")}
          </Link>
        </div>
        {t("ALL_RIGHT_RESERVED", { year: new Date().getFullYear() })}
        <br /> {t("DESIGNATE_TRADEMARK")}
      </div>
    </div>
  );
};

export default SideBar;
